var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCartAdded = function SvgCartAdded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.987.375a.22.22 0 0 1 .296.135c1.44 4.214 7.417 4.242 8.863.03a.223.223 0 0 1 .309-.129l1.785.912c.245.125.438.336.543.593l2.213 5.429a1.17 1.17 0 0 1-.692 1.551l-1.428.487a1.13 1.13 0 0 1-1.309-.458l-.464-.714a1.2 1.2 0 0 1-.192-.645v7.918c0 .643-.51 1.164-1.14 1.164H12.46c.11-.444.17-.907.17-1.385 0-3.197-2.623-5.79-5.857-5.79-.585 0-1.15.087-1.683.244V7.566c0 .23-.066.454-.19.645l-.467.714a1.13 1.13 0 0 1-1.308.458l-1.429-.487a1.17 1.17 0 0 1-.691-1.551l2.198-5.392c.114-.28.33-.502.603-.622z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.84.02c1.772.815 3.598.998 5.743.048.168-.074.348.077.28.246-1.147 2.82-5.175 2.813-6.306-.05-.067-.17.115-.32.283-.243"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.774 10.526c2.646 0 4.79 2.12 4.791 4.737C11.565 17.879 9.42 20 6.774 20s-4.792-2.12-4.792-4.737 2.145-4.737 4.792-4.737m-1.038 5.53-1.303-1.214-.888.884 2.19 2.097 3.989-3.974-.888-.885z"
  })));
};
export default SvgCartAdded;